export const ACTIONS = {
  EDIT: 'EDIT',
  VIEW: 'VIEW'
}

export const SUBJECTS = {
  SAVINGS_GOALS_COMMUNITY: 'Savings Goals Community',
  SAVINGS_GOALS_HS: 'Savings Goals',
  SAVINGS_GOALS_HISTORY: 'Savings Goals History'
}
